import {
    FETCH_WHOIS_REQUEST,
    FETCH_WHOIS_SUCCESS,
    FETCH_WHOIS_FAILURE,
} from './types/whois-action-types';

import MimirService from '../services/mimir-service';

function fetchWhoisRequest(){
    return {
        type: FETCH_WHOIS_REQUEST,
    };
}

function fetchWhoisSuccess( whois, domain ){
    return {
        domain,
        type: FETCH_WHOIS_SUCCESS,
        whois,
    };
}

function fetchWhoisFailure( error ){
    return {
        error,
        type: FETCH_WHOIS_FAILURE,
    };
}

export function fetchWhois( domain ){
    return ( dispatch, getState, { DATA_API } ) => {
        dispatch( fetchWhoisRequest() );
        const api = new MimirService( DATA_API );

        return api.getWhois( domain ).then(
            ( whois ) => dispatch( fetchWhoisSuccess( whois, domain ) ),
            ( error ) => dispatch( fetchWhoisFailure( error ) )
        );
    };
}

